import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:8085/api",
  baseURL: "https://datacomco.com:8085/api",
});
